import React, { Component } from 'react';
interface State {
  hasError: boolean;
  error: Error | null;
}
interface ErrorBoundaryProps {
  children: React.ReactNode;
}
export class ErrorBoundary extends Component<ErrorBoundaryProps, State> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
      error: null
    };
  }
  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error
    };
  }
  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[ErrorBoundary]', error, info);
  }
  render() {
    if (this.state.hasError) {
      return <div className="min-h-screen bg-background py-12 flex items-center justify-center" data-id="element-73" data-mp="lr2qs7irru4d">
          <div className="bg-white rounded-3xl shadow-lg max-w-lg w-full p-8 mx-4" data-id="element-74" data-mp="gssq5hea01bd">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-75" data-mp="1e9zvmss7wk2p">
              <span className="text-3xl" data-id="element-76" data-mp="19hg9v8jdmimt">⚠️</span>
            </div>
            <h2 className="text-2xl font-black text-gray-900 mb-2 text-center" data-id="element-77" data-mp="3n4rh18unuwcc">
              Greška u prikazu
            </h2>
            <p className="text-gray-600 text-center mb-6" data-id="element-78" data-mp="3s32qhih1n4u1">
              Nešto je pošlo po krivu. Pokušajte osvježiti stranicu.
            </p>
            <div className="bg-gray-50 p-4 rounded-xl mb-4 text-xs font-mono text-gray-700 overflow-x-auto" data-id="element-79" data-mp="3ddna8wf52hsl">
              <strong data-id="element-80" data-mp="34etc31m5tjcx">Greška:</strong>{' '}
              {this.state.error?.message || 'Nepoznata'}
              {this.state.error?.stack && <pre className="mt-2 text-[10px] whitespace-pre-wrap" data-id="element-81" data-mp="38h6crbm1ur2u">
                  {this.state.error.stack.split('\n').slice(0, 5).join('\n')}
                </pre>}
            </div>
            <button onClick={() => window.location.reload()} className="w-full py-3 bg-gray-900 text-white font-bold rounded-xl hover:bg-gray-800" data-id="element-82" data-mp="2zg8jnod5g3z1">
              Osvježi stranicu
            </button>
          </div>
        </div>;
    }
    return this.props.children;
  }
}